import { makeObservable, observable, runInAction, action, makeAutoObservable } from 'mobx';
import { FileServices } from '../services/fileServices';
import i18n from 'i18next';
import { toast } from "react-toastify";

const delay = (ms) => new Promise(
    resolve => setTimeout(resolve, ms)
);

const items = [
    { id: 1, "title": "Template1","text": "<h1><strong>Lorem ipsum</strong></h1><p><br></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Malesuada fames ac turpis egestas sed tempus. Placerat vestibulum lectus mauris ultrices eros in cursus. Amet massa vitae tortor condimentum. Vitae justo eget magna fermentum iaculis eu non diam phasellus. Nam aliquam sem et tortor consequat id porta. Sapien et ligula ullamcorper malesuada proin libero. Massa id neque aliquam vestibulum morbi. Ut enim blandit volutpat maecenas volutpat blandit aliquam etiam. Tincidunt tortor aliquam nulla facilisi cras fermentum odio eu. Eu facilisis sed odio morbi. Erat nam at lectus urna duis convallis convallis. Viverra accumsan in nisl nisi. Adipiscing diam donec adipiscing tristique risus nec. Ultrices mi tempus imperdiet nulla. Praesent elementum facilisis leo vel fringilla est. Dui nunc mattis enim ut tellus.</p><p><br></p><p>Nibh venenatis cras sed felis eget velit. Lorem sed risus ultricies tristique nulla aliquet enim tortor. In tellus integer feugiat scelerisque varius morbi enim. Sem integer vitae justo eget magna. Ut morbi tincidunt augue interdum velit euismod in pellentesque massa. Pharetra diam sit amet nisl. Varius vel pharetra vel turpis. Sit amet mattis vulputate enim nulla. At erat pellentesque adipiscing commodo. Lectus vestibulum mattis ullamcorper velit sed ullamcorper. Ultricies mi eget mauris pharetra et ultrices. Amet tellus cras adipiscing enim eu turpis egestas pretium aenean. Eu nisl nunc mi ipsum faucibus. Eleifend quam adipiscing vitae proin sagittis nisl. Pretium vulputate sapien nec sagittis aliquam malesuada. Quisque sagittis purus sit amet volutpat. Arcu cursus euismod quis viverra nibh. Et pharetra pharetra massa massa.</p>"},
    { id: 2, "title": "Template2", "text": "<h1><strong>Lorem ipsum 2</strong></h1><p><br></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Malesuada fames ac turpis egestas sed tempus. Placerat vestibulum lectus mauris ultrices eros in cursus. Amet massa vitae tortor condimentum. Vitae justo eget magna fermentum iaculis eu non diam phasellus. Nam aliquam sem et tortor consequat id porta. Sapien et ligula ullamcorper malesuada proin libero. Massa id neque aliquam vestibulum morbi. Ut enim blandit volutpat maecenas volutpat blandit aliquam etiam. Tincidunt tortor aliquam nulla facilisi cras fermentum odio eu. Eu facilisis sed odio morbi. Erat nam at lectus urna duis convallis convallis. Viverra accumsan in nisl nisi. Adipiscing diam donec adipiscing tristique risus nec. Ultrices mi tempus imperdiet nulla. Praesent elementum facilisis leo vel fringilla est. Dui nunc mattis enim ut tellus.</p><p><br></p><p>Nibh venenatis cras sed felis eget velit. Lorem sed risus ultricies tristique nulla aliquet enim tortor. In tellus integer feugiat scelerisque varius morbi enim. Sem integer vitae justo eget magna. Ut morbi tincidunt augue interdum velit euismod in pellentesque massa. Pharetra diam sit amet nisl. Varius vel pharetra vel turpis. Sit amet mattis vulputate enim nulla. At erat pellentesque adipiscing commodo. Lectus vestibulum mattis ullamcorper velit sed ullamcorper. Ultricies mi eget mauris pharetra et ultrices. Amet tellus cras adipiscing enim eu turpis egestas pretium aenean. Eu nisl nunc mi ipsum faucibus. Eleifend quam adipiscing vitae proin sagittis nisl. Pretium vulputate sapien nec sagittis aliquam malesuada. Quisque sagittis purus sit amet volutpat. Arcu cursus euismod quis viverra nibh. Et pharetra pharetra massa massa.</p>" },
];

export default class FilesStore {    

    
    rootStore;
    documents= [];
    document={};
    /*vatSettings = [];
    currencies= [];*/
  //template = {};

  constructor(rootStore) {
      this.rootStore = rootStore;

      makeObservable(this, {
          documents: observable,
          document: observable,
          upload: action,
          uploadImage: action,
          deleteDocument: action,
          getFullReportFile:action
          /*currencies: observable,
          getCurrencies:action*/
          /*template: observable,
          getAll: action,
          //get:action,
          reset: action,
          save: action,
          remove: action,
          duplicate:action*/
      });
    }
    getAttachmentFile = async (id) => {
        try {
            const data = await FileServices.getAttachmentFile(id);
            return data;
        } catch {
            return null;
        }
    }

    getDocumentFile = async (id) => {
        try {
            const data = await FileServices.getDocumentFile(id);
            return data;
        } catch {
            return null;
        }
    }
    deleteDocument = async (id) => {
        try {
            const data = await FileServices.deleteDocument(id);            
        } catch {
            return null;
        }
    }

    getInvoiceFile = async (id, showReport) => {
        try {
            const data = await FileServices.getInvoiceFile(id, showReport);
            return data;
        } catch {
            return null;
        }
    }
    getReportFile = async (clientId,projectId,devId,month) => {
        try {
            const data = await FileServices.getReportFile(clientId, projectId, devId, month);
            return data;
        } catch {
            return null;
        }
    }

    getFullReportFile = async (devId, month) => {
        try {
            const data = await FileServices.getFullReportFile(devId, month);
            return data;
        } catch {
            return null;
        }
    }

    getAll = async (page, filter, sort) => {
        try {
            const data = await FileServices.getAll({ page: page, filter: filter, sort: sort });
            runInAction(() => { this.documents = data; })
        }
        catch (error) {
            runInAction(() => { this.documents = []; });
        }
    }

    getAllWithOptions = async (options/*page, filter, sort*/) => {
        try {
            const data = await FileServices.getAllWithOptions(options/*{ page: page, filter: filter, sort: sort }*/);
            runInAction(() => {
                this.documents = data;
            })
        }
        catch (error) {
            runInAction(() => {
                this.documents = [];
            });
        }
    }

    uploadAttachment = async (file) => {
        try {
            const data = await FileServices.uploadAttachment(file);
            return data;
            //runInAction(() => { /*this.vatSettings = data;*/ });
        } catch (error) {
            //runInAction(() => { /*this.vatSettings = {};*/ })
        }
    }

    upload = async (file) => {
        try {            
            const data = await FileServices.upload(file);
            runInAction(() => { /*this.vatSettings = data;*/ });
        } catch (error) {
            runInAction(() => { /*this.vatSettings = {};*/})
        }
    }

    uploadImage = async (file) => {
        try {
            const data = await FileServices.uploadImage(file);
            //runInAction(() => { console.log(data)/*this.vatSettings = data;*/ });
            return data;
        } catch (error) {
            runInAction(() => { /*this.vatSettings = {};*/})
        }
    }

    /*getImage = async (file) => {
        try {
            const data = await FileServices.getImage(file);            
            return data;
        } catch (error) {
            return null;
        }
    }*/

    /*getVATs = async (id) => {
        try {
            const data = await UtilsServices.getTVAs();
            runInAction(() => { this.vatSettings = data;});
        } catch (error) {
            runInAction(() => { this.vatSettings = {};})
        }
    };
    getCurrencies = async (id) => {
        try {
            const data = await UtilsServices.getCurrencies();
            runInAction(() => { this.currencies = data; });
        } catch (error) {
            runInAction(() => { this.currencies = {}; })
        }
    };*/
}